import React, { Component } from "react";
import "./SearchProdTile.css";

class SearchProdTile extends Component {
	render() {
		let classes;
		if (this.props.activated) {
			switch (this.props.activated) {
				case true:
					classes = "search-prod-tile selected-tile";
					break;
				case false:
					classes = "search-prod-tile";
					break;
				default:
					classes = "search-prod-tile";
			}
		} else {
			switch (this.props.searchType) {
				case true:
					classes = "search-prod-tile selected-search-type";
					break;
				case false:
					classes = "search-prod-tile alt-search-type";
					break;
				default:
					classes = "search-prod-tile";
			}
		}

		return (
			<div
				className={classes}
				onClick={() => this.props.onClick(this.props.name)}
			>
				<img src={this.props.icon} alt={this.props.name} />
				<p>{this.props.name}</p>
			</div>
		);
	}
}

export default SearchProdTile;


// WEBPACK FOOTER //
// ./src/components/SearchProdTile/SearchProdTile.js